import React from 'react';
import { Mail, ArrowRight, Phone, MapPin, Calendar } from 'lucide-react';

/**
 * Enhanced CTA Component - Smartsocs-inspired
 */

const CTA: React.FC = () => {
    return (
        <section id="contact" className="py-24 bg-gradient-to-br from-[#0a1628] via-[#153860] to-[#0a1628] relative overflow-hidden">
            {/* Background */}
            <div
                className="absolute inset-0 opacity-50"
                style={{
                    backgroundImage: `
                        radial-gradient(circle at 20% 50%, rgba(85, 195, 189, 0.15) 0%, transparent 50%),
                        radial-gradient(circle at 80% 50%, rgba(238, 118, 35, 0.1) 0%, transparent 50%)
                    `
                }}
            />

            <div className="max-w-5xl mx-auto px-6 relative z-10">
                <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-10 md:p-16 text-center">
                    {/* Header */}
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                        Ready to Accelerate Your
                        <span className="block text-[#55C3BD]">Silicon Development?</span>
                    </h2>

                    <p className="text-white/60 text-lg max-w-2xl mx-auto mb-10">
                        Whether you need specialized talent, turnkey project delivery, or a dedicated
                        engineering center, our team is ready to discuss your semiconductor challenges.
                    </p>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                        <a
                            href="mailto:vlsi@lancesoft.com"
                            className="group px-8 py-4 bg-[#EE7623] text-white font-semibold rounded-lg flex items-center justify-center gap-3 hover:bg-[#ff8a3d] transition-all duration-300 shadow-lg shadow-[#EE7623]/25"
                        >
                            <Mail size={20} />
                            Get In Touch
                            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                        </a>
                        <a
                            href="#"
                            className="px-8 py-4 border-2 border-white/30 text-white font-semibold rounded-lg flex items-center justify-center gap-3 hover:bg-white/10 hover:border-white/50 transition-all duration-300"
                        >
                            <Calendar size={18} />
                            Schedule a Call
                        </a>
                    </div>

                    {/* Contact Info */}
                    <div className="flex flex-wrap justify-center gap-8 pt-8 border-t border-white/10">
                        <div className="flex items-center gap-3 text-white/60">
                            <Mail size={18} className="text-[#55C3BD]" />
                            <span>vlsi@lancesoft.com</span>
                        </div>
                        <div className="flex items-center gap-3 text-white/60">
                            <Phone size={18} className="text-[#55C3BD]" />
                            <span>+1 (703) 554-9060</span>
                        </div>
                        <div className="flex items-center gap-3 text-white/60">
                            <MapPin size={18} className="text-[#55C3BD]" />
                            <span>Herndon, VA (HQ)</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTA;
